import {
  CryptoAlertData,
  CryptoAlertsPage,
  GetRecentAlertsParams,
  LeaderboardAlertsResponse,
  PreviousAlert,
} from "@crypto-trading/common/browser";
import { ApiClientManager } from "@/utils/api-client-factory";

/**
 * Crypto Alerts API functions
 */

/**
 * Get recent listing alerts
 */
export const getRecentListings = async (
  userId: string,
  params?: GetRecentAlertsParams
): Promise<CryptoAlertsPage> => {
  const client = ApiClientManager.getCryptoAlertsClient();
  const getListings = client.getRecentListings.bind(client) as (
    userId: string,
    options?: GetRecentAlertsParams
  ) => Promise<CryptoAlertsPage>;
  return getListings(userId, params);
};

/**
 * Get recent delisting alerts
 */
export const getRecentDelistings = async (
  userId: string,
  params?: GetRecentAlertsParams
): Promise<CryptoAlertsPage> => {
  const client = ApiClientManager.getCryptoAlertsClient();
  const getDelistings = client.getRecentDelistings.bind(client) as (
    userId: string,
    options?: GetRecentAlertsParams
  ) => Promise<CryptoAlertsPage>;
  return getDelistings(userId, params);
};

/**
 * Get crypto alert by ID
 */
export const getAlertById = async (
  alertId: string
): Promise<CryptoAlertData | null> => {
  return ApiClientManager.getCryptoAlertsClient().getAlertById(alertId);
};

/**
 * Get leaderboard alerts (last 20 listings + 20 delistings with price)
 */
export const getLeaderboardAlerts =
  async (): Promise<LeaderboardAlertsResponse> => {
    return ApiClientManager.getCryptoAlertsClient().getLeaderboardAlerts();
  };

/**
 * Get incoming listings (pre-market/roadmap/soon-spot/soon-futures, no price yet)
 */
export const getIncomingListings = async (): Promise<CryptoAlertData[]> => {
  return ApiClientManager.getCryptoAlertsClient().getIncomingListings();
};

/**
 * Get previous alerts (listings and delistings) for a currency
 */
export const getPreviousAlerts = async (
  userId: string,
  currency: string,
  alertId?: string
): Promise<PreviousAlert[]> => {
  return ApiClientManager.getCryptoAlertsClient().getPreviousAlerts(
    userId,
    currency,
    alertId
  );
};
